import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csidentifier(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };
  
return(
      <div>
      <Sides/>

      <Helmet>
 
 <title>Learn Free PHP Identifier Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php identifier tutorial for beginners.identifier in Php blank space special symbol is not allowed ,it must begin with a letters,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,php unique identifier,tutorial for begineers,Php identifier,php identifier rules,php identifiers,php unique identifier for a computer,Php identifier for,identifier foreach Php" />
 <link rel="canonical" href="https://www.codeexampler.com/php-identifier" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Php Identifier </h1>
    <div className="first">
        <a href="/php-keyword">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-comments">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Identifier In Php:</h2>
    <p className="mt-4 para"><span className="bold">1, Identifier In Php</span> is a name given to a variable method.<br/>
2, Blank space special symbol is not allowed <br/>
3, It must begin with letters<br/>
4, You don’t use any keyword in the same manner means or Uppercase, and lowercase are different means <br/>
</p>



<h2 className='headings'>Uppercase and Lowercase Example</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">{"\n"}
            <span className="qwerty-10">my_name </span>
            {"\n"}
            <span className="qwerty-4">My_Name </span>
              {"\n"} {"\n"}
              <span className="qwerty-11">both means are different </span>
              {"\n"} {"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">Rules of identifier in Php :</h2>
<h3  className="mt-4 mh3"> 1, Blank Space Special Symbol in Php</h3>



      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code >{"\n"}
            <span className="qwerty-2">code-exampler </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">false </span>
            {"\n"}
            <span className="qwerty-2">code.exampler </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">false </span>
            {"\n"}
            <span className="qwerty-10">code_exampler </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-7">true </span>
            {"\n"}
            <span className="qwerty-10">codeexampler </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-7">true </span>
            {"\n"}
            <span className="qwerty-2">code exampler </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">false </span>
            {"\n"}
              {"\n"} 
          </code>
        </pre>
</div>


<h2 className="mt-4 mh2">2, It Must Begin With Letters Identifier in Php Example:</h2>

      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-5">Int -2a; </span>
            <span className="qwerty-3">- </span>
            <span className="qwerty">wrong </span>
            {"\n"}
            <span className="qwerty-1">Int a2 </span>
            <span className="qwerty-3">- </span>
            <span className="qwerty-4">true </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">Int _24a </span>
            <span className="qwerty-3">- </span>
            <span className="qwerty">wrong </span>
              {"\n"} {"\n"}
          </code>
        </pre>
      </div>



<h2 className="mt-4 mh2">3, We Don’t use any Reserved keyword means:<br/></h2>


      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">{"\n"}
            <span className="qwerty-10">int if; </span>
            <span className="qwerty-3">- </span>
            <span className="qwerty-11">false </span>
            {"\n"}
            <span className="qwerty-4">int IF; </span>
            <span className="qwerty-3">- </span>
            <span className="qwerty">true </span>
              {"\n"} {"\n"}
          </code>
        </pre>
      </div>



<h2 className="mt-4 mh2">4, We only type less than 31 characters long <br/></h2>


      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-4">&#36; a;</span>
            <span className="qwerty-2"> &#47;&#47; This declare a variable means a is a variable</span>
            {"\n"}
            <span className="qwerty-4">&#36; a = </span>
            <span className="qwerty-6">4;</span>
            <span className="qwerty-2"> &#47;&#47; This assigns 4 to (a) means assigns a variable a value</span>
              {"\n"} {"\n"}
          </code>
        </pre>
      </div>


  <h1 className="mt-5">  </h1>
      
  <div className="back">
        <a href="/php-keyword">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-comments">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csidentifier;